export const PASTE_TOOLBAR_CLASS = 'ak-editor-paste-toolbar';
export const PASTE_TOOLBAR_MENU_ID = 'ak-editor-paste-toolbar-item-dropdownList';
export const TEXT_HIGHLIGHT_CLASS = 'text-highlight';
export const PASTE_HIGHLIGHT_DECORATION_KEY = 'paste-highlight-decoration-key';
export const PASTE_TOOLBAR_ITEM_CLASS = 'ak-editor-paste-toolbar-item';
export const EDITOR_WRAPPER_CLASS = 'akEditor';
export const PASTE_OPTIONS_TEST_ID = 'paste-options-testid';
export const PASTE_OPTIONS_META_ID = 'paste-options$';

// Gap (in px) between the right edge of the pasted content and the left edge of the paste menu.
export const PASTE_MENU_GAP = 12;
